import React, {useEffect, useState} from "react";
import {Redirect, Route} from "react-router-dom";
import isLogin from "../utils/isLogin";
import {useDispatch, useSelector} from "react-redux";
import {useRecoilState} from "recoil";
import {userState} from "../state/globalState";

const PrivateRoute = ({component: Component, ...rest}) => {
    const [userInfo, setUserInfo] = useRecoilState(userState)
    const [isResponseSuccess, setIsResponseSuccess] = useState(false);
    const [isTmpCont, setIsTmpCont] = useState(false);
    const [isLoginSuccess, setIsLoginSuccess] = useState(false);
    const [isSurvey, setIsSurvey] = React.useState("0");

    useEffect(() => {
        isLogin().then((res) => {
            const { user, surveyYn } = res.payload;
            if (!user.admnNo) {
                window.location.replace("/");
                return;
            }

            const newUserInfo = {
                ...user,
                surveyYn
            }
            setUserInfo(newUserInfo);

            if (surveyYn === "1" && (rest.path === "/agree" || rest.path === "/survey")) {
                window.location.replace("/result-mail");
                return;
            }

            setIsSurvey(surveyYn);
        });
    }, []);

    useEffect(() => {
        if (userInfo.admnNo) {
            setIsLoginSuccess(true);
            setIsResponseSuccess(true);
        }
    }, [userInfo]);

    return (
        isResponseSuccess && isLoginSuccess && (
            <Route {...rest} render={props => (
                isLoginSuccess ?
                    <Component isTmpCont={isTmpCont} {...props} />
                    : <Redirect to={isSurvey === "1" ? "/result-mails" : "/"} />
            )} />
        )
    )
};

export default PrivateRoute;
